import React, { useEffect } from 'react';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { IconWrapper } from './InvoicesItems';
import { setPendingInvoiceTab } from '../../../../../Components/InvoiceTool/pendingInvoiceTab';

const ViewInvoiceEye = ({ invoice, setSelectedFeesIds, handleInvoiceCellClick }) => {
  useEffect(() => {
    if (invoice) {
      const _selectedFeesIds = invoice.fees.map(fee => fee.id);
      setSelectedFeesIds(_selectedFeesIds);
    }
  }, [invoice]);

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (invoice?.invoicePdf) {
      window.open(invoice.invoicePdf, '_blank');
      return;
    }
    // No stored PDF yet — open a blank tab now (inside the user gesture so
    // the browser doesn't block it), let the pipeline generate the PDF,
    // and ViewInvoiceModal will navigate this same tab when it's ready.
    // We intentionally do NOT pass 'noopener' here: spec says window.open
    // with noopener returns null, and we need the tab reference to navigate it.
    const pending = window.open('', '_blank');
    if (pending) {
      try {
        pending.document.write(
          '<title>Preparing invoice…</title><body style="font-family:Segoe UI,sans-serif;color:#555;margin:40px;">Preparing invoice…</body>'
        );
      } catch {
        /* cross-origin write may be denied — fine, just leave it blank */
      }
    }
    setPendingInvoiceTab(pending);
    handleInvoiceCellClick(invoice);
  };

  return (
    <IconWrapper hasPdf>
      <div onClick={handleClick} title="Open invoice in new tab" role="button">
        <VisibilityIcon />
      </div>
    </IconWrapper>
  );
};

export default ViewInvoiceEye;
